module.exports = __webpack_public_path__ + "static/media/undraw_departing.fcd877fc.png";